var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-api-middleware/node_modules/core-js/library/modules/$.core.js
// module id = 77
// module chunks = 1 2 3